<p-toast key="global-toast"></p-toast>
<p-confirmDialog />
<router-outlet></router-outlet>
